// src/security/instance.ts
import Keycloak, { KeycloakConfig } from 'keycloak-js'

const baseUrl = import.meta.env.VITE_KEYCLOAK_URL as string
const realm = import.meta.env.VITE_KEYCLOAK_REALM as string

// Separa os clientIds
const clientId = window.location.pathname.startsWith('/expert')
  ? (import.meta.env.VITE_KEYCLOAK_CLIENT_EXPERT as string)
  : (import.meta.env.VITE_KEYCLOAK_CLIENT_GUEST as string)

const config: KeycloakConfig = {
  url: baseUrl,
  realm,
  clientId,
}

export const keycloakInstance = new Keycloak(config)
